import React from "react";
import { Field, ErrorMessage, useFormikContext, getIn } from "formik";
import AITranslateButton from "components/common/AITranslateButton";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Icons } from "assets/icons";

const CustomField = ({
  label,
  name,
  type = "text",
  placeholder,
  className = "",
  as = "input",
  isArabic = false,
  isReadOnly = false,
  icon = null,

  enableTranslate = false,
  translateTo = "ar", // "ar" or "en"
  targetField = null, // field to update after translation
  infoText = null,
  required = null,
  autoComplete = "off",
  disabled = false,
  value,
  ...rest
}) => {
  const { info } = Icons || {};
  const { touched, errors } = useFormikContext();

  // Use getIn to handle nested field paths like "title.en"
  const fieldTouched = getIn(touched, name);
  const fieldError = getIn(errors, name);

  return (
    <div className="w-100 position-relative">
      {label && (
        <label htmlFor={name}>
          {label}
          {required && <span className="text-danger">*</span>}{" "}
          {infoText && (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>{infoText}</Tooltip>}
            >
              <img
                src={info}
                alt="info"
                width={15}
                height={15}
                style={{ cursor: "pointer" }}
              />
            </OverlayTrigger>
          )}
        </label>
      )}

      {icon && <img src={icon} alt="" className="input_icon" />}

      <Field
        name={name}
        disabled={disabled}
        type={type}
        as={as}
        id={name}
        readOnly={isReadOnly}
        placeholder={placeholder}
        className={`form-control ${isArabic ? "rtl" : ""} ${
          icon ? "has_icon" : ""
        } ${fieldTouched && fieldError ? "is-invalid" : ""} ${className}`}
        autoComplete={autoComplete}
        {...(value !== undefined && { value })}
        {...rest}
      />

      {enableTranslate && targetField && (
        <AITranslateButton
          sourceField={name}
          targetField={targetField}
          translateTo={translateTo}
          isNestedField={name.includes(".")}
        />
      )}

      <ErrorMessage name={name} component="div" className="text-danger" />
    </div>
  );
};

export default CustomField;
